import Select from './LqVAutocomplete'
export default Select.extend({
    name: 'lq-v-combobox',
    data () {
        return {
            tagName: 'v-combobox'
        }
    }
})